module.exports = __webpack_public_path__ + "static/img/1958_Darmstadt_WaterMusic_6.92f0376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_Darmstadt_WaterMusic_6.jpg
// module id = te7H
// module chunks = 0